module.exports = __webpack_public_path__ + "img/bannerWithOutstream.359cc262.png";